/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Or_Continue_WithInputs */

const en_auth_or_continue_with = /** @type {(inputs: Auth_Or_Continue_WithInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`or continue with`)
};

const de_auth_or_continue_with = /** @type {(inputs: Auth_Or_Continue_WithInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`oder weiter mit`)
};

const fr_auth_or_continue_with = /** @type {(inputs: Auth_Or_Continue_WithInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ou continuer avec`)
};

const es_auth_or_continue_with = /** @type {(inputs: Auth_Or_Continue_WithInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`o continuar con`)
};

const it_auth_or_continue_with = /** @type {(inputs: Auth_Or_Continue_WithInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`o continua con`)
};

const nl_auth_or_continue_with = /** @type {(inputs: Auth_Or_Continue_WithInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`of doorgaan met`)
};

const pl_auth_or_continue_with = /** @type {(inputs: Auth_Or_Continue_WithInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lub kontynuuj przez`)
};

const fi_auth_or_continue_with = /** @type {(inputs: Auth_Or_Continue_WithInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tai jatka käyttäen`)
};

const da_auth_or_continue_with = /** @type {(inputs: Auth_Or_Continue_WithInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eller fortsæt med`)
};

const sv_auth_or_continue_with = /** @type {(inputs: Auth_Or_Continue_WithInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eller fortsätt med`)
};

/**
* | output |
* | --- |
* | "or continue with" |
*
* @param {Auth_Or_Continue_WithInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const auth_or_continue_with = /** @type {((inputs?: Auth_Or_Continue_WithInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Or_Continue_WithInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_auth_or_continue_with(inputs)
	if (locale === "fr") return fr_auth_or_continue_with(inputs)
	if (locale === "es") return es_auth_or_continue_with(inputs)
	if (locale === "it") return it_auth_or_continue_with(inputs)
	if (locale === "nl") return nl_auth_or_continue_with(inputs)
	if (locale === "pl") return pl_auth_or_continue_with(inputs)
	if (locale === "fi") return fi_auth_or_continue_with(inputs)
	if (locale === "da") return da_auth_or_continue_with(inputs)
	if (locale === "sv") return sv_auth_or_continue_with(inputs)
	return en_auth_or_continue_with(inputs)
});